import reactStringReplace from 'react-string-replace';

import { Anchor, Alert as ConstAlert, Text } from '@zillow/constellation-10';

import { useSelector } from '../../../../selectors/useSelector';

import { LISTING_SUMMARY_DISPLAY_STATUS } from '../../../../constants/ListingSummaryConstants';

const Alert = () => {
  const {
    currentProperty: {
      syndication: {
        universal: { message = '', replaceUrl = '', replaceText = '' } = {},
        overview: { displayStatus = '' } = {},
      } = {},
    },
  } = useSelector((state) => state.properties);

  const tone = displayStatus === LISTING_SUMMARY_DISPLAY_STATUS.DECLINED ? 'critical' : 'warning';

  const renderedMessage = reactStringReplace(message, replaceText, () => (
    <Text>
      <Anchor
        href={replaceUrl}
        target="_blank"
        css={{ _hover: { textDecoration: 'none' }, _visited: { color: 'text.accent.brand.hero' } }}
      >
        {replaceText}
      </Anchor>
    </Text>
  ));

  if (message && replaceText) {
    return <ConstAlert tone={tone}>{renderedMessage}</ConstAlert>;
  }

  return null;
};

export default Alert;
